import { Container, Toolbar } from "@mui/material";
import CancelIcon from "../../../assets/icons/x-icon.svg?react";
import LogoLg from "../../../assets/logo.png";
import LogoMd from "../../../assets/logo.png";
import LogoSm from "../../../assets/logo-80.png";
import {
  HeaderContainer,
  IconButtonStyled,
  Logo,
  LogoContainer,
} from "./MobileDrawer.styled";
import { breakpoints } from "../../../constants/breakpoints";

interface MobileDrawerHeaderProps {
  handleOpenDrawer: () => void;
}

const MobileDrawerHeader: React.FC<MobileDrawerHeaderProps> = ({
  handleOpenDrawer,
}) => {
  return (
    <HeaderContainer position={"relative"}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
          <LogoContainer>
            <Logo>
              <source
                media={`(min-width:${breakpoints.tablet}px)`}
                srcSet={LogoLg}
                height={89}
              />
              <source
                media={`(min-width:${breakpoints.mobile}px)`}
                srcSet={LogoMd}
                height={60}
              />
              <img src={LogoSm} alt="BP Consulting Logo" />
            </Logo>
          </LogoContainer>
          <IconButtonStyled
            size="large"
            aria-label="open navigation drawer"
            onClick={handleOpenDrawer}
          >
            <CancelIcon />
          </IconButtonStyled>
        </Toolbar>
      </Container>
    </HeaderContainer>
  );
};

export default MobileDrawerHeader;
